import { render, staticRenderFns } from "./WhiteTable.vue?vue&type=template&id=f1904af2&scoped=true&"
import script from "./WhiteTable.vue?vue&type=script&lang=js&"
export * from "./WhiteTable.vue?vue&type=script&lang=js&"
import style0 from "./WhiteTable.vue?vue&type=style&index=0&id=f1904af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1904af2",
  null
  
)

export default component.exports